/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://rzetjuopfrg3jje6pwveifljmm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-x66ehkcq7vapniojuwetvhissi",
    "aws_cognito_identity_pool_id": "us-east-1:4b6d9f83-b4c6-47d0-8e4d-ce2b7123bd8d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_invECNK1w",
    "aws_user_pools_web_client_id": "5deltjd5bfhvmct0095tv75cv8",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "10",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "gestoraudienciasapp-20230329141314-hostingbucket-test",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1i9jugbht4r97.cloudfront.net",
    "aws_user_files_s3_bucket": "bucketgestoraudienciasapp205051-test",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
